<template>
  <DsIslandsContainer>
    <DsIsland align-center>
      <DsResultBanner
        type="negative"
        size="small"
      >
        <template #title>
          <span v-html="translate('goldkid-reject:impossible')"></span>
        </template>
<!--        <template #description>-->
<!--          <span v-html="translate('goldkid-reject:has-tax')"></span>-->
<!--        </template>-->
      </DsResultBanner>
    </DsIsland>
    <DsButtonBar sticky>
      <DsButton size="large" @click="goHome">
        {{ translate('goldkid-open-failed:btn') }}
      </DsButton>
    </DsButtonBar>
  </DsIslandsContainer>
</template>
<script setup>
import { DsResultBanner, DsIsland, DsIslandsContainer, DsButtonBar, DsButton } from '@ds/vue2';

const goHome = () => {
  window.location.href = process.env.VUE_APP_BASE_URL
}

</script>
